<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar title="修改菜品" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
    <!--导航栏 end-->
    <!--内容部分 start-->
    <van-form ref="forms" style="margin-top: 1.5rem">
      <van-field
        v-model="name"
        label="菜品名称"
        required
        name="菜品名称"
        clearable
        placeholder="请输入菜品名称"
        :rules="[{ required: true, message: '菜品名称不能为空' }]"
      />
      <van-cell
        :value="select_list.name"
        is-link
        title="选择分类"
        @click="show = true"
        required
        :rules="[{ required: true, message: '分类必须选择' }]"
      />
      <van-action-sheet
        title="选择分类"
        v-model="show"
        :actions="classList"
        cancel-text="取消"
        close-on-click-action
        @select="selectList"
        @cancel="onCancel"
      />
      <van-field
        name="是否单规格"
        label="是否单规格"
        required
        :rules="[{ required: true, message: '是否单规格必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="is_spec" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="price"
        v-if="is_spec == 1"
        label="价格"
        type="number"
        required
        name="价格"
        clearable
        placeholder="请输入价格"
        :rules="[{ required: true, message: '价格不能为空' }]"
      />
      <div v-else name="规格设置" label="规格设置" class="specs">
        <!-- 添加规格 -->
        <div>
          <label title="规格组">
            <input type="text" v-model="specs_key" placeholder="请输入规格名" />
            <button type="button" @click="setSpecs('key')">添加</button>
          </label>
          <div v-for="(item_key,index_key) in specs" :key="index_key">
            <div class="specs_key">
              <span>{{item_key.key}}</span>
              <span class="del_key" @click="delSpecs('key',index_key)"></span>
            </div>
            <div>
              <div
                class="specs_value"
                v-for="(item_value,index_value) in item_key.value"
                :key="index_value"
              >
                <span>{{item_value}}</span>
                <span class="del_value" @click="delSpecs('value',index_key,index_value)"></span>
              </div>
              <label title="规格值">
                <input type="text" v-model="specs_value[index_key]" placeholder="请输入规格值" />
                <button type="button" @click="setSpecs('value',index_key)">添加</button>
              </label>
            </div>
          </div>
        </div>
        <!-- 配置规格 -->
        <div class="sku" v-if="specs.length > 0">
          <table border="1" cellpadding="2" cellspacing="0" bordercolor="#e9e9e9">
            <thead>
              <tr>
                <th v-for="(item_key,index_key) in specs" :key="index_key">{{item_key.key}}</th>
                <th>
                  价格
                  <label>
                    <input type="number" v-model="sku_price" placeholder="请输入价格" />
                    <button type="button" @click="setSkuPrice()">设置</button>
                  </label>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in sku" :key="index">
                <td v-for="(item_name,index_name) in item.name" :key="index_name">{{item_name}}</td>
                <td>
                  <input type="number" v-model="sku[index].price" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <van-field
        v-model="pack_price"
        type="number"
        label="打包费"
        required
        name="打包费"
        clearable
        placeholder="请输入打包费"
        :rules="[{ required: true, message: '打包费不能为空' }]"
      />
      <van-field name="状态" label="状态" required :rules="[{ required: true, message: '状态必须选择' }]">
        <template #input>
          <van-radio-group v-model="status" direction="horizontal">
            <van-radio :name="1">上架</van-radio>
            <van-radio :name="0">下架</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="前台是否单独打印"
        label="前台是否单独打印"
        required
        :rules="[{ required: true, message: '是否单独打印必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="alone_printer" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="后厨是否单独打印"
        label="后厨是否单独打印"
        required
        :rules="[{ required: true, message: '是否单独打印必须选择' }]"
      >
        <template #input>
          <van-radio-group v-model="chef_alone_printer" direction="horizontal">
            <van-radio :name="1">是</van-radio>
            <van-radio :name="0">否</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        name="uploader"
        label="菜品图片"
        required
        :rules="[{ required: true, message: '图片不能为空' }]"
      >
        <template #input>
          <van-uploader :after-read="afterRead" v-model="imageList" multiple :max-count="1" />
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        label="前台打印机"
        :value="printer_sn"
        placeholder="选择前台打印机"
        @click="show_printer = true"
      />
      <van-popup v-model="show_printer" round position="bottom" closeable>
        <!-- <van-picker
          show-toolbar
          :columns="printer_list"
          @cancel="show_printer = false"
          @confirm="onConfirm4"
        />-->
        <div style="padding: 50px 0px;">
          <van-checkbox-group v-model="checkedValue" @change="changeCheckebox">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in printer_list"
                clickable
                :key="index"
                :title="item.device_sn"
              >
                <template #right-icon>
                  <van-checkbox :name="item.device_sn" ref="checkboxes" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
      <van-field
        readonly
        clickable
        label="后厨打印机"
        :value="chef_sn"
        placeholder="选择后厨打印机"
        @click="show_printer_chef = true"
      />
      <van-popup v-model="show_printer_chef" round position="bottom" closeable>
        <div style="padding: 50px 0px;">
          <van-checkbox-group v-model="checkedValueChef" @change="changeChef">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in printer_list_chef"
                clickable
                :key="index"
                :title="item.device_sn"
              >
                <template #right-icon>
                  <van-checkbox :name="item.device_sn" ref="checkboxess" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </div>
      </van-popup>
      <van-field v-model="rank" label="排序值" name="排序值" clearable placeholder="请输入排序值" />
    </van-form>
    <div style="margin: 16px;">
      <van-button @click="onSubmit" round block type="info" native-type="submit">确定</van-button>
    </div>

    <!--内容部分 end-->
    <!-- 裁剪图片 -->
    <Cutting
      :width="150"
      :height="150"
      :img="Cutting_img"
      @upload="upload"
      @close="close"
      v-if="Cutting_show"
    ></Cutting>
  </div>
</template>

<script>
import Cutting from "@/components/Cutting.vue";
import { Notify, Toast } from "vant";
import Config from "../../../config";
export default {
  name: "FoodUpdate",
  components: {
    Cutting,
  },
  data() {
    return {
      Cutting_show: false,
      Cutting_img: {},
      show: false,
      select_list: {},
      classList: [],
      imageList: [{ url: "" }],
      name: "",
      rank: "",
      class_id: "",
      price: "",
      status: 1,
      is_spec: 1,
      alone_printer: 0,
      chef_alone_printer: 1,
      specs: [],
      specs_key: "",
      specs_value: [],
      sku: [],
      sku_price: "",
      pack_price: "",
      printer_sn: "",
      show_printer: false,
      show_printer_chef: false,
      printer_list: [],
      activeIndexList: [],
      indexList: [],
      activeIndexListCode: [],
      checkedValue: [],
      printer_list_chef: [],
      checkedValueChef: [],
      chef_sn: "",
    };
  },
  watch: {
    sku: {
      handler: function (newVal, oldVal) {
        return newVal.map((item) => {
          // item.price = Number(item.price);
          if (
            item.price.toString().split(".").length > 1 &&
            item.price.toString().split(".")[1].toString().length > 2
          ) {
            item.price = item.price < 0 ? 0 : item.price;
            item.price = Number(item.price).toFixed(2);
          }
          return item;
        });
      },
      deep: true,
    },
    pack_price: function (value) {
      if (
        value.toString().split(".").length > 1 &&
        value.toString().split(".")[1].toString().length > 2
      ) {
        value = value < 0 ? 0 : value;
        value = Number(value).toFixed(2);
      }
      this.pack_price = value;
    },
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = "#f5f5f5";
    next();
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "";
    next();
  },
  created() {
    this.id = this.$route.query.id;
    this.listClass();
    this.getFood();
    this.deviceList();
  },
  methods: {
    changeCheckebox(e) {
      console.log("--=====", e);
      this.printer_sn = e.toString();
    },
    changeChef(e) {
      console.log("--=====", e);
      this.chef_sn = e.toString();
    },
    // toggle(item, index) {
    //   console.log(item);
    //   this.$refs.checkboxes[index].toggle();
    //   this.activeIndexListCode.push(item.device_sn); // 选项code
    //   let arrCode = [];
    //   for (let i = 0; i < this.activeIndexListCode.length; i++) {
    //     if (arrCode.indexOf(this.activeIndexListCode[i]) == -1) {
    //       //选中的新数组里面没有相同的数据push到选中的新数组里面
    //       arrCode.push(this.activeIndexListCode[i]);
    //     } else if (arrCode.indexOf(this.activeIndexListCode[i]) > -1) {
    //       //选中的新数组里面有相同的数据，去掉选中的新数组里面的值,代表点击的行已被点击过，这次点击则删除选中数组里面的值
    //       let index = arrCode.indexOf(this.activeIndexListCode[i]);
    //       arrCode.splice(index, 1);
    //     }
    //   }

    //   this.activeIndexListCode = arrCode;
    //   this.printer_sn = this.activeIndexListCode.toString();

    //   console.log(this.printer_sn);
    // },
    deviceList() {
      this.$http.post("/wechat/api.store.index/deviceList").then((response) => {
        this.printer_list = response.data.data;
        this.printer_list_chef = response.data.data;
        console.log("=======", this.printer_list);
        // response.data.data.forEach((element) => {
        //   console.log(element);
        //   let obj = {
        //     text: element.device_sn,
        //   };
        //   this.printer_list.push(obj);
        // });
      });
    },
    onConfirm4(value) {
      console.log(value);
      this.printer_sn = value.text;
      this.show_printer = false;
    },
    getFood() {
      this.$http
        .post("/wechat/api.store_food/getFood", { id: this.id })
        .then((response) => {
          if (response && response.body.code == 200) {
            this.name = response.body.rows.name;
            this.rank = response.body.rows.rank;
            this.select_list.name = response.body.rows.class_name;
            this.select_list.id = response.body.rows.class_id;
            this.status = response.body.rows.status;
            this.price = response.body.rows.price;
            this.is_spec = response.body.rows.is_spec;
            this.alone_printer = response.body.rows.alone_printer;
            this.chef_alone_printer = response.body.rows.chef_alone_printer;
            this.specs = response.body.rows.specs;
            this.sku = response.body.rows.sku;
            this.pack_price = response.body.rows.pack_price;
            this.printer_sn = response.body.rows.printer_sn;
            if (response.body.rows.printer_sn) {
              this.checkedValue = response.body.rows.printer_sn.split(",");
            }
            this.chef_sn = response.body.rows.chef_sn;
            if (response.body.rows.chef_sn) {
              this.checkedValueChef = response.body.rows.chef_sn.split(",");
            }
            if (response.body.rows.picture) {
              this.imageList[0].url =
                Config.baseURL + response.body.rows.picture;
              this.picture = response.body.rows.picture;
            } else {
              this.imageList = [];
              this.picture = null;
            }
          }
        });
    },
    selectList(action, index) {
      this.select_list = action;
      this.show = false;
    },
    onCancel() {
      Toast("取消");
      this.class_id = [];
    },
    listClass() {
      this.$http.post("/wechat/api.store_class/listClass").then((response) => {
        if (response && response.body.code == 200) {
          this.classList = response.body.rows;
          // response.body.rows.map(item=>{
          // 	item.name=item.store_name;
          // })
        }
      });
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      this.Cutting_img = file.content;
      this.Cutting_show = true;
    },
    // 获取裁剪后的图片
    upload(baseimg) {
      this.Cutting_show = false;
      this.$http
        .post("/wechat/api.merchant/wechatUploadMerchantImg", {
          localData: baseimg,
          openid: window.localStorage.getItem("openid"),
        })
        .then((response) => {
          if (response && response.data.code == 200) {
            this.picture = response.data.local_img;
            this.imageList = [{ url: response.data.url_img }];
          }
        });
    },
    // 关闭裁剪
    close(status) {
      this.Cutting_show = status;
      this.imageList = [];
    },

    // 左侧返回
    onClickLeft() {
      this.$router.push("/FoodList");
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      if (this.is_spec == 1) {
        if (this.price <= 0) {
          Notify({ type: "danger", message: "价格不能小于等于0" });
          return;
        }
      } else {
        for (let item of this.sku) {
          if (item.price <= 0) {
            Notify({ type: "danger", message: "价格不能小于等于0" });
            return;
          }
        }
      }
      this.$refs.forms
        .validate()
        .then(() => {
          var toast = Toast.loading({
            duration: 0,
            message: "修改中",
            forbidClick: true,
            loadingType: "spinner",
          });
          this.$http
            .post("/wechat/api.store_food/editFood", {
              id: this.id,
              name: this.name,
              class_id: this.select_list.id,
              price: this.price,
              pack_price: this.pack_price,
              picture: this.picture,
              status: this.status,
              rank: this.rank,
              is_spec: this.is_spec,
              alone_printer: this.alone_printer,
              chef_alone_printer: this.chef_alone_printer,
              specs: this.specs,
              sku: this.sku,
              printer_sn: this.printer_sn,
              chef_sn: this.chef_sn,
              // openid: window.localStorage.getItem("openid")
            })
            .then((response) => {
              toast.clear();
              if (response && response.data.code == 200) {
                this.$router.push("/FoodList");

                // VueCookie.set('salesmanInfo', response.data.data, 360000);
                // window.location.href = that.redirect;
              } else {
                Notify({ type: "danger", message: response.data.msg });
              }
            });
        })
        .catch(() => {
          this.$toast.fail("必填项未填写");
        });
      // window.sessionStorage.setItem("tag",this.ta)
      //  var that = this;
    },
    // 添加规格
    setSpecs(type, index = 0) {
      // 判断不能包含特殊字符
      var pattern = new RegExp("[,，]");
      if (
        type == "key" &&
        !pattern.test(this.specs_key) &&
        this.specs_key != ""
      ) {
        this.specs.push({ key: this.specs_key, value: [] });
        this.specs_key = "";
      } else if (
        type == "value" &&
        !pattern.test(this.specs_value[index]) &&
        this.specs_value[index] != ""
      ) {
        this.specs[index].value.push(this.specs_value[index]);
        this.specs_value[index] = "";
      } else {
        this.specs_key = "";
        this.specs_value[index] = "";
        Notify({
          type: "danger",
          message: "输入框不能为空并且不能包含特殊字符",
        });
        return;
      }
      this.specsCalculation(); // 计算规格
    },
    // 删除规格
    delSpecs(type, index_key = 0, index_value = 0) {
      if (type == "key") {
        this.specs.splice(index_key, 1);
      } else if (type == "value") {
        this.specs[index_key].value.splice(index_value, 1);
      }
      this.specsCalculation(); // 计算规格
    },
    // 计算规格
    specsCalculation() {
      var arr = [];
      for (let item of this.specs) {
        arr.push(item.value);
      }
      // last为上次运算的结果，current为数组中的当前元素
      var calculation = arr.reduce((last, current) => {
        var array = [];
        last.forEach((par1) => {
          current.forEach((par2) => {
            array.push(par1 + "," + par2);
          });
        });
        return array;
      });
      this.sku = [];
      for (let item of calculation) {
        this.sku.push({ name: item.split(","), price: 0 });
      }
    },
    // 批量设置价格
    setSkuPrice() {
      for (let index in this.sku) {
        this.$set(this.sku[index], "price", this.sku_price);
      }
      this.sku_price = "";
    },
  },
};
</script>

<style >
.van-icon-goods-collect-o::before {
  position: relative;
  top: 0.1rem;
}
.van-icon-contact::before {
  position: relative;
  top: 0.1rem;
}

.van-field >>> .van-field__label {
  width: 30px;
}
.specs {
  background: white;
  font-size: 0.3rem;
  padding: 0.2rem 0.2rem 0.2rem 3rem;
}
.specs::before {
  content: attr(name);
  position: absolute;
  left: 0.42667rem;
  font-size: 0.37333rem;
}
.specs label {
  width: 100%;
  height: 0.8rem;
  display: flex;
  font-weight: 400;
  margin: 0.1rem 0;
  box-sizing: border-box;
}
.specs label[title]::before {
  content: attr(title);
  background: rgba(25, 137, 250, 0.6);
  color: white;
  padding: 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  flex: 1;
}
.specs label input {
  width: 3.4rem;
  border: none;
  height: 100%;
  box-sizing: border-box;
  border: 0.04rem solid #1989fa;
}
.specs label button {
  border: none;
  flex: 1;
  height: 100%;
  color: white;
  background: #1989fa;
  box-sizing: border-box;
  padding: 0;
}
.specs .specs_key {
  height: 0.8rem;
  display: flex;
  align-items: center;
  font-size: 0.4rem;
}
.specs .specs_key + div {
  display: flex;
  flex-wrap: wrap;
}
.specs .del_key {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  background: #e9e9e9;
  border-radius: 100%;
  margin-left: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.specs .del_key::hover {
  background: #999;
}
.specs .del_key::after,
.specs .del_value::after {
  content: "x";
  font-size: 0.4rem;
}
.specs .specs_value {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(25, 137, 250, 0.6);
  margin: 0.1rem 0.1rem 0.2rem 0;
  height: 0.7rem;
}
.specs .specs_value span:first-child {
  padding: 0 0.1rem;
  color: white;
}
.specs .del_value {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.4rem;
  height: 100%;
  background: rgba(25, 137, 250, 0.8);
  color: white;
}
.specs .del_value::hover {
  background: rgba(25, 137, 250, 1);
}
.specs .sku {
  width: 6.5rem;
  max-height: 8rem;
  overflow: auto;
}
.specs .sku table {
  width: 100%;
}
.specs .sku table thead th {
  position: sticky;
  top: 0;
  background: white;
}
.specs .sku table th,
.specs .sku table td {
  text-align: center;
}
.specs .sku table thead input {
  width: 2.1rem;
  color: #444;
}
.specs .sku table td input {
  width: 1.5rem;
}
.specs .sku table thead label {
  width: 3.4rem;
  margin: 0.1rem auto;
}
</style>
